import React from "react";
import { withStyles, withTheme } from "@material-ui/core";
import { compose } from "recompose";
import RouteKPI from "./RouteKPI";
import RouteStopDetails from "./RouteStopDetails";
import { getRouteDeviationData } from "../NextStopComplianceUtills";

const styles = (theme) => ({
  container: {
    padding: "5%",
    overflowY: "auto",
    overflowX: "hidden",
    height: "83%",
  },
  smallText: {
    fontSize: "11px",
    lineHeight: "15px",
    color: theme.iconColor,
    padding: "12px 0px",
  },
  headerText: {
    fontWeight: "bold",
    fontSize: 16,
    color: theme.iconColor,
    lineHeight: "21px",
  },
  subHeaderText: {
    fontWeight: "600",
    fontSize: theme.textFontSize,
    lineHeight: "16px",
    color: theme.iconColor,
  },
  subHeaderTextRed: {
    fontWeight: "600",
    fontSize: theme.textFontSize,
    lineHeight: "16px",
    color: theme.deviationStopPopupColor,
    paddingTop: "12px",
  },
  topPadding: {
    paddingTop: "24px",
  },
});

const EndOfDayRouteCompliance = ({
  classes,
  routeData,
  selectedRoute,
  routeComplianceData,
  terminalCode,
  stopChange,
}) => {
  const routeDeviationData = getRouteDeviationData(
    routeComplianceData,
    terminalCode
  );
  return (
    <div className={`${classes.container} customScroll`}>
      <RouteKPI routeData={routeData}></RouteKPI>
      <div className={`${classes.headerText} ${classes.topPadding}`}>
        Stop Deviations
      </div>
      <div className={classes.smallText}>
        Stop Deviation occurs when the driver decides to go to a different stop
        compared to what was proposed (planned stop) to him on his mobile app at
        the time.
      </div>
      <div className={classes.subHeaderText}>
        Total Stop Deviations {routeDeviationData.length}
      </div>
      {routeComplianceData.routeType === "TenderedToAgent" && (
        <div className={classes.subHeaderTextRed}>
          This route is tendered to agent route
        </div>
      )}
      <RouteStopDetails
        stopChange={stopChange}
        selectedRoute={selectedRoute}
        routeComplianceData={routeComplianceData}
        routeDeviationData={routeDeviationData}
      ></RouteStopDetails>
    </div>
  );
};
export default compose(
  withStyles(styles),
  withTheme()
)(EndOfDayRouteCompliance);
